import cogoToast from "cogo-toast"
import { SubHeader } from "../../Common/layout/SubHeader";
import React, { useEffect, useRef, useState } from "react"
import { Button } from "react-bootstrap"
import { useDownloadKYCReportMutation } from "../../../../redux/apiSlice"
import { Card, CardBody, CardHeader, CardHeaderToolbar } from "../../../../_metronic/_partials/controls"
import DynamicSimpleTable from "../../../util/DynamicSimpleReactTable"
import { errorMessage, formatDate, formatStatus, formatUsername, ucFirst } from "../../../util/Helpers"
import { ViewIcon } from "../../../util/Icons"
import { Permissions, PermissionType } from "../../../util/Permissions"
import { FilterGroup } from "../../Common/components/FilterGroup"
import { Permission } from "../../Common/layout/Permission"
import ViewKycModal from "./modal/ViewKycModal"

export const VerifiedKYCTable = ({ match: { params: { userGroup, status } } }) => {
    const tableRef = useRef();
    const [
        downloadKYCReport,
        {
            isLoading: isLoadingReport,
            isSuccess: isReportGenerating,
            error: errorReport,
        }
    ] = useDownloadKYCReportMutation()

    useEffect(() => {
        if (errorReport) {
            cogoToast.error(errorReport.data);
        }
    }, [errorReport])

    useEffect(() => {
        if (isReportGenerating) {
            cogoToast.success(`KYCs export in progress. The resulting file will be sent to your mail.`);
        }
    }, [isReportGenerating])

    const [kycModal, setKycModal] = useState({ showKycModal: false, userId: null, action: null });

    /* Modal show/hide Toggle */
    const toggleModal = modal => _ => {
        setKycModal({ ...kycModal, [modal]: !kycModal[modal] })
    }

    /* Action Buttons */
    const pendingKycView = row => {

        return (
            <span style={{ whiteSpace: "nowrap" }}>
                <Button
                    title="View KYC"
                    className="btn btn-icon btn-light btn-hover-primary btn-sm  bg-white"
                    onClick={_ => setKycModal({ ...kycModal, showKycModal: true, userId: row.userId, action: row.action })}
                >
                    <span className="svg-icon svg-icon-md svg-icon-primary">
                        <ViewIcon />
                    </span>
                </Button>
            </span>
        )
    }

    return (
        <div className="py-4 px-6">

            <FilterGroup key={`kyc-${userGroup}`} defaultFilters={{ "sortBy": "createdAt:desc" }}>
                <FilterGroup.DateRange className={"mb-5"} />
                <FilterGroup.Content>
                    {
                        ({ filters }) => (
                            <Card>
                                <CardHeader title={`Verified KYCs`}>
                                    <CardHeaderToolbar>

                                        <div style={{ marginLeft: '10px' }}></div>

                                        <FilterGroup.Filter className={"bg-black"} width="300px" name={"sortBy"} label={"Filter"} menuAnchorRight>
                                            <FilterGroup.Option value={"createdAt:desc"}>Created At ( Descending )</FilterGroup.Option>
                                            <FilterGroup.Option value={"createdAt:asc"}>Created At ( Ascending )</FilterGroup.Option>
                                            <FilterGroup.Option value={"statusUpdatedAt:desc"}>Status Updated At ( Descending )</FilterGroup.Option> 
                                            <FilterGroup.Option value={"statusUpdatedAt:asc"}>Status Updated At ( Ascending )</FilterGroup.Option>
                                        </FilterGroup.Filter>


                                       
                                        <div style={{ marginLeft: '10px' }}></div>
                                        


                                        <FilterGroup.Filter className={"bg-black"} width="300px" name={"kycLevel"} label={"KYC Level"} menuAnchorRight>
                                        <FilterGroup.Option value={0}>All</FilterGroup.Option>
                                            <FilterGroup.Option value={1}>Level One</FilterGroup.Option>
                                            <FilterGroup.Option value={2}>Level Two</FilterGroup.Option>
                                        </FilterGroup.Filter>

                                        <div style={{ marginLeft: '10px' }}></div>


                                        <FilterGroup.Filter className={"bg-black"} width="300px" name={"approvalType"} label={"Approval Mode"} menuAnchorRight>
                                            <FilterGroup.Option value={""}>All</FilterGroup.Option>
                                            <FilterGroup.Option value={"automatic"}>Automatic Verification</FilterGroup.Option>
                                            <FilterGroup.Option value={"manual"}>Manual Verification</FilterGroup.Option>
                                        </FilterGroup.Filter>

                                        <div style={{ margin: '0 8px' }}></div>

                                        <Permission permission={Permissions.REPORTS} permissionType={PermissionType.CREATE}>
                                            <button
                                                type="button"
                                                className="btn btn-primary"
                                                disabled={isLoadingReport}
                                                onClick={() => downloadKYCReport({
                                                    userGroup,
                                                    startDate: filters?.startDate || "",
                                                    endDate: filters?.endDate || "",
                                                    format: "csv",
                                                })}
                                            >
                                                Export CSV
                                            </button>
                                        </Permission>

                                    </CardHeaderToolbar>
                                </CardHeader>
                                <CardBody>
                                    <DynamicSimpleTable
                                        key={`${status}-kyc-${userGroup}`}
                                        queryParams={
                                            `startDate=${filters?.startDate || ""}`
                                            + `&endDate=${filters?.endDate || ""}`
                                            + `&sortBy=${filters?.sortBy || ""}`
                                            + `&userType=${filters?.userType || ""}`
                                            + `&approvalType=${filters?.approvalType || ""}`
                                            + `&kycLevel=${filters?.kycLevel || 0}`
                                            + `&action=${""}`
                                            + `&status=${"verified"}`


                                        }
                                        source={{ url: `/pending-kyc/user-group/${userGroup}/verified` }}
                                        columns={[
                                            {
                                                title: "NAME",
                                                format: row => formatUsername(row.userId, `${row.firstName} ${row.lastName}`)
                                            },
                                            { title: "EMAIL", key: "email" },
                                            { title: "PHONE", key: "phone" },
                                            {
                                                title: "LEVEL",
                                                format: row => {
                                                    if (row.kycLevel === 3) {
                                                        return 2;
                                                    } else if (row.kycLevel === 2 && row.status === "pending") {
                                                        return 1;
                                                    } else {
                                                        return row.kycLevel;
                                                    }
                                                }
                                            },
                                            {
                                                title: "STATUS",
                                                key: "status",
                                                format: row => {
                                                    if (row.kycLevel === 2 && row.status === "pending") {
                                                        return formatStatus("verified");
                                                    } else {
                                                        return formatStatus(row.status);
                                                    }
                                                }
                                            },
                                            ...status !== "declined" ? [{
                                                title: "ACTION",
                                                key: "action"
                                            }] : [],
                                            { title: "Approval Mode", key: "approvalType" },
                                            { title: "COMPLETION", format: row => `${row.completion}%` },
                                            { title: "CREATED AT", format: row => formatDate(row.created) },
                                            { title: "STATUS UPDATED AT", format: row => formatDate(row.statusUpdatedAt) },
                                            { title: "", format: pendingKycView }
                                        ]}

                                        ref={tableRef}
                                        onError={err => cogoToast.error(errorMessage(err))}
                                        refreshIcon={true}
                                    />
                                </CardBody>
                            </Card>
                        )
                    }
                </FilterGroup.Content>
            </FilterGroup>
            {
                kycModal.showKycModal &&
                <ViewKycModal {...{ ...kycModal, userGroup, tableRef }} onHide={toggleModal("showKycModal")} />
            }
        </div >
    )
}